import React from "react"
import { Box, Chip } from "@material-ui/core"
import { CancelOutlined } from "@material-ui/icons"
import { makeStyles } from "@material-ui/styles"
import { USER_ACCREDITATIONS_STATUS, USER_TRAINING_STATUS } from "../../data"

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(0.25),
    marginBottom: theme.spacing(0.25),
    fontWeight: 500,
    color: theme.palette.text.light,
  },
}))

const FilterChip = ({ label, onDelete }) => {
  const classes = useStyles()

  return (
    <Chip label={label} onDelete={onDelete} deleteIcon={<CancelOutlined />} size="small" className={classes.chip} />
  )
}

const FiltersChips = ({ data, filters, hasSchedules, onDelete }) => {
  const handleFilterDelete = (filter) => {
    onDelete(filter)
  }

  return (
    <Box display="flex" flexWrap="wrap">
      {filters
        .filter((filter) => filter.type !== "schedules" || hasSchedules)
        .map((filter) => {
          const { type, value } = filter
          const key = `${type}-${value}`
          switch (type) {
            case "roles":
              return (
                <FilterChip
                  key={key}
                  label={data.rolesData.roles.find((item) => item.id === value).friendlyName}
                  onDelete={() => handleFilterDelete(filter)}
                />
              )
            case "groups":
            case "locations":
            case "trainingCourses":
              return (
                <FilterChip
                  key={key}
                  label={data[`${type}Data`][type].find((item) => item.id === value).name}
                  onDelete={() => handleFilterDelete(filter)}
                />
              )
            case "schedules":
            case "status":
              return (
                <FilterChip
                  key={key}
                  label={`${value.charAt(0).toUpperCase()}${value.slice(1)}`}
                  onDelete={() => handleFilterDelete(filter)}
                />
              )
            case "trainingStatus": {
              let label
              switch (value) {
                case USER_TRAINING_STATUS.IN_PROGRESS:
                  label = "Training in progress"
                  break
                case USER_TRAINING_STATUS.COMPLETE:
                  label = "Training complete"
                  break
                case USER_TRAINING_STATUS.OVERDUE:
                  label = "Training overdue"
                  break
                default:
                  label = "No training assigned"
              }

              return <FilterChip key={key} label={label} onDelete={() => handleFilterDelete(filter)} />
            }
            case "accreditationStatus": {
              let label
              switch (value) {
                case USER_ACCREDITATIONS_STATUS.AWAITING:
                  label = "Awaiting accreditations"
                  break
                case USER_ACCREDITATIONS_STATUS.WARNING:
                  label = "Accreditations expiring"
                  break
                case USER_ACCREDITATIONS_STATUS.EXPIRED:
                  label = "Accreditations expired"
                  break
                case USER_ACCREDITATIONS_STATUS.COMPLIANT:
                  label = "Accreditations current"
                  break
                default:
                  label = "No accreditations assigned"
              }

              return <FilterChip key={key} label={label} onDelete={() => handleFilterDelete(filter)} />
            }
            default:
              throw new Error("Unmapped filter type")
          }
        })}
    </Box>
  )
}

export { FiltersChips }
